import { Card, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Lock } from "lucide-react";

export function SolutionTab({ profile, update }) {
  const hasIdea = !profile.no_idea && (profile.market_opportunity || profile.therapeutic_area);
  
  if (!hasIdea) {
    return (
      <div className="space-y-4">
        <h2 className="text-xl font-bold">Your Solution</h2>
        <Card className="bg-slate-50">
          <CardContent className="p-8 text-center">
            <Lock className="w-12 h-12 text-slate-300 mx-auto mb-4" />
            <p className="text-slate-500">Define your idea first (previous tab)</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Your Solution</h2>
      <Card><CardContent className="p-4 space-y-4">
        <div><Label>Solution</Label><Textarea value={profile.solution_description || ""} onChange={e => update("solution_description", e.target.value)} rows={3} placeholder="Describe your solution" /></div>
        <div><Label>Technology</Label><Textarea value={profile.technology_approach || ""} onChange={e => update("technology_approach", e.target.value)} rows={2} /></div>
        <div><Label>Stage</Label>
          <Select value={profile.development_stage || ""} onValueChange={v => update("development_stage", v)}>
            <SelectTrigger><SelectValue placeholder="Select" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="concept">Concept</SelectItem>
              <SelectItem value="early">Early Research</SelectItem>
              <SelectItem value="preclinical">Preclinical</SelectItem>
              <SelectItem value="clinical">Clinical</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div><Label>Why You?</Label><Textarea value={profile.why_you || ""} onChange={e => update("why_you", e.target.value)} rows={2} /></div>
        <div><Label>Defensibility</Label><Textarea value={profile.defensibility || ""} onChange={e => update("defensibility", e.target.value)} rows={2} /></div>
        <div><Label>vs Standard of Care</Label><Textarea value={profile.vs_standard_of_care || ""} onChange={e => update("vs_standard_of_care", e.target.value)} rows={2} /></div>
      </CardContent></Card>
    </div>
  );
}
